import { FC, JSX, useContext } from "react";
import { ProviderHubContext, ProviderHubContextProvider } from "./contexts/ProviderHubContext";
import { ProviderHubBannerMessages } from "@app/projects/network-assessment/provider-hub/ProviderHubBannerMessages";
import { viewToComponentMap } from "./contexts/viewToComponentMap";

const WrappedProviderHubLandingPage: FC = (): JSX.Element => {
  const providerHubContext = useContext(ProviderHubContext);

  return (
    <div className="provider-hub_landing-page-main-container">
      <ProviderHubBannerMessages />
      {viewToComponentMap.get(providerHubContext.view)}
    </div>
  );
}

const ProviderHubLandingPage: FC = () => {
  return (
    <ProviderHubContextProvider>
      <WrappedProviderHubLandingPage />
    </ProviderHubContextProvider>
  )
};

export default ProviderHubLandingPage;